import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles({
    imageButton: {
        width: '200px',
    },
});
/**
 * SmartCheckの強制終了ボタン画像コンポーネント
 * @param props
 */
export var SmartCheckForceButton = function (props) {
    var classes = useStyles(props);
    if (props.imageUrl) {
        // クーポンマスタで画像が登録されている場合は、その画像を出す
        return React.createElement("input", { type: "image", src: props.imageUrl, className: classes.imageButton, alt: "SmartCheck\u753B\u50CF" });
    }
    else {
        // 登録されていない場合は、デフォルトの画像でボタンを表示する
        return (React.createElement("input", { type: "image", src: "/smartCheck-force-button-default.gif", className: classes.imageButton, alt: "SmartCheck\u5F37\u5236\u7D42\u4E86\u30DC\u30BF\u30F3\u753B\u50CF" }));
    }
};
//# sourceMappingURL=SmartCheckForceButton.js.map